import { Box, Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import LanguageContext from "context/LanguageContext";
import { useContext } from "react";

const useStyles = makeStyles()((theme: Theme) => ({
	wrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "column",
		height: "100svh",
		padding: theme.spacing(2),
	},
	number: {
		fontSize: theme.spacing(15),
		fontWeight: 600,
		color: theme.palette.violet.main,
		lineHeight: "100%",
	},
	title: {
		fontSize: theme.spacing(4.5),
		fontWeight: 500,
		color: theme.palette.violet.main,
		marginTop: theme.spacing(3.5),
		marginBottom: theme.spacing(2.5),
		lineHeight: "100%",
		textAlign: "center",
	},
	subTitle: {
		color: theme.palette.violet.main,
		fontSize: theme.spacing(2.25),
		whiteSpace: "pre-wrap",
		textAlign: "center",
		lineHeight: "120%",
	},
}));

export const UnknownPage = () => {
	const { classes } = useStyles();
	const { getTranslate } = useContext(LanguageContext);
	return (
		<Box className={classes.wrapper}>
			<Typography className={classes.number}>404</Typography>
			<Typography className={classes.title} data-lang="unknownPage.title">
				{getTranslate("unknownPage.title")}
			</Typography>
			<Typography className={classes.subTitle} data-lang="unknownPage.subTitle">
				{getTranslate("unknownPage.subTitle")}
			</Typography>
		</Box>
	);
};
